export default {
    API_URL: 'https://staging.api.studiomolotov.com.br/',
    CLIENT_SECRET: '3b4DCyHHyoMwk1VvkaZujtb8IwnBvRYfYD75oKs7',
    GRANT_TYPE: 'password',
    CLIENT_ID: '2',
    PUSHER_APP_KEY: '66824d8739c0181af28e',
    PUSHER_APP_CLUSTER: 'mt1',
    UPLOAD_LIMIT: 5,
    LOCALE: 'en',
};
